// Reglas del formulario de un campo propio (QA F1 #14), puras: las opciones de una
// lista se escriben una por línea; sin vacías ni repetidas, y al editar solo se
// agregan (la regla del API: quitar una invalidaría los documentos que la usan).

export const DATA_TYPES = ['text', 'number', 'date', 'boolean', 'select'] as const;

/** Una opción por línea, sin espacios al borde ni líneas vacías. */
export function parseOptions(text: string): string[] {
  return text
    .split(/\r?\n/)
    .map((o) => o.trim())
    .filter((o) => o !== '');
}

/** Error de las opciones de una lista, o null. `existing` = las que ya tiene el campo. */
export function optionsError(
  options: readonly string[],
  existing: readonly string[] = [],
  required = true,
): string | null {
  if (required && options.length === 0 && existing.length === 0) {
    return 'Escribe al menos una opción, una por línea';
  }
  const repeated = options.find((o, i) => options.indexOf(o) !== i);
  if (repeated !== undefined) {
    return `La opción «${repeated}» está repetida`;
  }
  const taken = options.find((o) => existing.includes(o));
  if (taken !== undefined) {
    return `La opción «${taken}» ya existe`;
  }
  if (options.some((o) => o.length > 120)) {
    return 'Cada opción admite hasta 120 caracteres';
  }
  return null;
}

// Aviso por fecha (reunión 2026-10-27): días antes de la fecha, de 0 a 365; vacío = sin aviso.
const REMINDER = /^\d{1,3}$/;

/** Días del campo "Avisar días antes": null si está vacío, undefined si es inválido. */
export function parseReminder(text: string): number | null | undefined {
  const t = text.trim();
  if (t === '') {
    return null;
  }
  const n = Number(t);
  return REMINDER.test(t) && n <= 365 ? n : undefined;
}

export const REMINDER_ERROR = 'Escribe un número de días entre 0 y 365.';

/** Texto de la lista: cuándo avisa un campo de fecha; null si no avisa. */
export function reminderText(days: number | null, overdue = false): string | null {
  const before =
    days === null
      ? null
      : days === 0
        ? 'el mismo día'
        : days === 1
          ? '1 día antes'
          : `${days} días antes`;
  if (before === null) {
    return overdue ? 'Avisa al vencer' : null;
  }
  return `Avisa ${before}${overdue ? ' y al vencer' : ''}`;
}
